import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import main_en from './lang/en/main.json';
import main_th from './lang/th/main.json';
import login_en from './lang/en/login.json';
import login_th from './lang/th/login.json';
import widget_en from './lang/en/widget.json';
import widget_th from './lang/th/widget.json';
import dashboard_en from './lang/en/dashboard.json';
import dashboard_th from './lang/th/dashboard.json';
import settings_en from './lang/en/settings.json';
import settings_th from './lang/th/settings.json';
import main_jp from './lang/jp/main.json';
import widget_jp from './lang/jp/widget.json';
import dashboard_jp from './lang/jp/dashboard.json';
import settings_jp from './lang/jp/settings.json';

const resources = {
  en: {
    main: main_en,
    login: login_en,
    widget: widget_en,
    dashboard: dashboard_en,
    settings: settings_en,
  },
  th: {
    main: main_th,
    login: login_th,
    widget: widget_th,
    dashboard: dashboard_th,
    settings: settings_th,
  },
  jp: {
    main: main_jp,
    widget: widget_jp,
    dashboard: dashboard_jp,
    settings: settings_jp,
  },
};

// Get language from URL path or default to English
const getLanguageFromPath = () => {
  const path = window.location.pathname;
  const langMatch = path.match(/^\/(en|th|jp)\//);
  return langMatch ? langMatch[1] : 'en';
};

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguageFromPath(),
    fallbackLng: 'en',
    ns: ['main'],
    interpolation: {
      escapeValue: false
    }
  });

export default i18next;